import type { DonationPost } from '../components/CardDonationPost/CardDonationPost';
import type { KidsPost, KidsPostComment } from '../types/kidsPost.types';
import { toDonationComment } from './bookRequest';

/** A photo post on the shared card: the caption as its text, photos without a URL left out. */
export const toMediaPost = (row: KidsPost, comments: KidsPostComment[] = []): DonationPost => ({
  ...toDonationComment({ ...row, content: row.caption ?? '' }),
  media: row.photos.flatMap((photo) =>
    photo.url ? [{ url: photo.url, width: photo.width_px, height: photo.height_px }] : []
  ),
  comments: comments.map(toDonationComment),
  commentCount: row.comment_count,
});
